import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";

const colors = ["bg-blue-500", "bg-red-500", "bg-gray-500"];

const getColor = (index) => {
  if (index === 2) return "bg-[#800000]";
  return colors[index % colors.length];
};

const OzonetelDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [agentData, setAgentData] = useState([]);
  const [totalAgents, setTotalAgents] = useState(0);
  const [skillCounts, setSkillCounts] = useState({});
  const [stateCounts, setStateCounts] = useState({});
  const [agentCategories, setAgentCategories] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);

  console.log("lastUpdated", lastUpdated);

  //   const fetchAgents = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${apiurl}/utils/ozonetel/get-agent-logins`
  //       ); // your backend route
  //       setAgentData(response.data.rawData);
  //       setTotalAgents(response.data.totalAgents);
  //       setSkillCounts(response.data.skillCounts);
  //       setStateCounts(response.data.stateCounts);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Failed to load data", error);
  //       setLoading(false);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchAgents();
  //   }, []);

  useEffect(() => {
    let intervalId;

    const fetchAgents = async () => {
      try {
        console.log("API call triggered at", new Date().toLocaleTimeString());
        const response = await axios.get(
          `${apiurl}/utils/ozonetel/get-agent-logins`
        );

        setAgentData(response.data.rawData);
        setTotalAgents(response.data.totalAgents);
        setSkillCounts(response.data.skillCounts);
        setStateCounts(response.data.stateCounts);
        setAgentCategories(response.data.agentCategories);
        setLoading(false);
        const timeNow = new Date().toLocaleTimeString();
        setLastUpdated(timeNow);
        console.log("Updated at", timeNow);
      } catch (error) {
        console.error("Failed to load data", error);
        setLoading(false);
      }
    };

    fetchAgents();
    intervalId = setInterval(fetchAgents, 20000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (lastUpdated) {
      console.log("lastUpdated updated:", lastUpdated);
    }
  }, [lastUpdated]);

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-4 max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">
            Ozonetel Agent Dashboard
            {lastUpdated && (
              <p className="text-sm text-gray-500 text-center mb-4">
                Last Updated: {lastUpdated}
              </p>
            )}
          </h1>

          {loading ? (
            <div className="text-center text-blue-500">Loading...</div>
          ) : (
            <>
              <motion.div
                className="bg-gray-100 p-4 mb-4 rounded-2xl shadow-sm border text-center"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
              >
                <div className="flex justify-between">
                  <div>
                    <p className="text-xl text-gray-600">Total Agents</p>
                    <p className="text-4xl font-bold text-blue-700">
                      {totalAgents}
                    </p>
                  </div>
                  <div>
                    <p className="text-xl text-gray-600">Sales Agents</p>
                    <p className="text-4xl font-bold text-blue-700">
                      {agentCategories.sales}
                    </p>
                  </div>
                  <div>
                    <p className="text-xl text-gray-600">Other Agents</p>
                    <p className="text-4xl font-bold text-blue-700">
                      {agentCategories.other}
                    </p>
                  </div>
                  <div>
                    <p className="text-xl text-gray-600">OJT Agents</p>
                    <p className="text-4xl font-bold text-blue-700">
                      {agentCategories.ojt}
                    </p>
                  </div>
                </div>
              </motion.div>
              {/* Top Big Card for StateCounts */}
              <div className="mb-6">
                <motion.div
                  className="bg-white p-6 rounded-2xl shadow-sm border"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                >
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    Agent States
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                    {Object.entries(stateCounts).map(
                      ([state, count], index) => (
                        <div
                          key={state}
                          className="bg-gray-100 p-4 rounded-xl text-center shadow-md"
                        >
                          <p className="text-lg text-gray-700">{state}</p>
                          <p className="text-2xl font-bold text-blue-700">
                            {count}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </motion.div>
              </div>
              {/* Smaller Cards for Skill Counts */}
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-8">
                {Object.entries(skillCounts).map(([skill, count], index) => {
                  const displaySkill = skill?.trim() || "Unknown";
                  const displayCount = typeof count === "number" ? count : 0;

                  return (
                    <motion.div
                      key={displaySkill + index}
                      className={`min-h-[80px] ${getColor(
                        index
                      )} text-white p-3 rounded-xl shadow-md text-center flex flex-col justify-center items-center`}
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.1 * index }}
                    >
                      <p className="text-[12px] font-medium">{displaySkill}</p>
                      <p className="text-xl font-bold">{displayCount}</p>
                    </motion.div>
                  );
                })}
              </div>

              {/* Count Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                {/* <motion.div
                  className="bg-gray-100 p-4 rounded-2xl shadow-xl text-center"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                >
                  <p className="text-xl text-gray-600">Total Agents</p>
                  <p className="text-4xl font-bold text-blue-700">
                    {totalAgents}
                  </p>
                </motion.div> */}
                {/* 
                {Object.entries(skillCounts).map(([skill, count], index) => {
                  const displaySkill = skill?.trim() || "Unknown";
                  const displayCount = typeof count === "number" ? count : 0;

                  return (
                    <motion.div
                      key={displaySkill + index}
                      className={`min-h-[100px] ${getColor(
                        index
                      )} text-white p-4 rounded-2xl shadow-xl text-center flex flex-col justify-center items-center`}
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.1 * index }}
                    >
                      <p className="text-xl font-medium">{displaySkill}</p>
                      <p className="text-3xl font-bold">{displayCount}</p>
                    </motion.div>
                  );
                })} */}
              </div>

              {/* Agent List Table */}
              <div className="bg-white shadow-md rounded-xl overflow-hidden">
                <h2 className="text-xl font-bold px-4 py-3 bg-gray-100 border-b">
                  Agent Details
                </h2>
                <div className="overflow-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          SN
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          Agent ID
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          Agent Name
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          Phone Number
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          Skill
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          State
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold text-gray-600">
                          Mode
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {agentData.map((agent, idx) => (
                        <tr
                          key={idx}
                          className="hover:bg-gray-50 transition-all"
                        >
                          <td className="px-4 py-2 text-sm text-gray-800">
                            {idx + 1}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-800">
                            {agent.AgentId}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {agent.AgentName}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {agent.PhoneNumber}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {agent.SkillName}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {agent.AgentState}
                          </td>
                          <td className="px-4 py-2 text-sm">{agent.Mode}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default OzonetelDashboard;
